import React, { memo } from 'react'
import { Box, LinearProgress, linearProgressClasses } from '@mui/material'
import { varAlpha } from 'minimal-shared/utils'

const CustomProgressBar = ({ title, label, completed, progressTextSx }) => {
  return (
    <Box
      sx={{
        minWidth: 0,
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      {title}
      <Box
        component='span'
        sx={{
          color: 'text.secondary',
          typography: 'caption',
          ...progressTextSx
        }}
      >
        {label}
      </Box>

      <Box
        sx={{
          width: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
      >
        <LinearProgress
          color='primary'
          variant='determinate'
          value={completed}
          sx={[
            (theme) => ({
              width: 1,
              height: 6,
              bgcolor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
              [` .${linearProgressClasses.bar}`]: { opacity: 0.8 }
            })
          ]}
        />
        <Box
          component='span'
          sx={{
            width: 40,
            typography: 'caption',
            color: 'text.secondary',
            fontWeight: 'fontWeightMedium',
            ...progressTextSx
          }}
        >
          {completed}%
        </Box>
      </Box>
    </Box>
  )
}

export default memo(CustomProgressBar)
